import * as React from 'react';
import {BottoneAPI, Trad} from '../../../index';
import * as Glob from '../../../../Globale';
import {DocumentList} from "./DocumentList";
import {DocumentHeader} from "./DocumentHeader";
import {DropEvent} from 'react-dropzone';
import {BasePureComponent} from "../../../BaseComponent";
import * as Dati from "../../../../Dati";
import {CustomDropzone} from "../../Dropzone/CustomDropzone";
import {CDocumentExtended} from "../../../../Dati";
import {CDocument} from "../../../../Dati";

export interface IDocumentBoxBasicProps {
    Files: Glob.DatiJSON;
    InputFile: File | null;
    Label?: any;
    SaveURL: string;
    AcceptedFiles?: string;
    ExtendedValues?: Dati.Dictionary<any> | Glob.DatiJSON;
}

interface IDocumentBoxProps extends IDocumentBoxBasicProps {
    OnComponentChange: () => void;
    OnDrop: (acceptedFiles: File[], rejectedFiles: File[], event: DropEvent) => any;
    OnFileSaved: (dati: Dati.CRisAPI) => void;
    OnDownloadFile: (document: Dati.CDocumentExtended) => void;
    OnErroreBottoneAPI: (sender: BottoneAPI) => void;
    OnSubmitSave: () => void;
    OnRemove: (file: CDocumentExtended) => void;
    AddEnabled?: boolean
}

export class DocumentBox extends BasePureComponent<IDocumentBoxProps> {
    public render() {
        let label: any = <div/>;
        if (this.props.Label != undefined) {
            if (typeof (this.props.Label) == "string") {
                label = <h3 className="kt-portlet__head-title">{this.props.Label}</h3>;
            } else {
                label = this.props.Label;
            }
        }

        let DropZone: any = null;
        if (this.props.AddEnabled != undefined && this.props.AddEnabled) {
            DropZone = <React.Fragment>
                <CustomDropzone OnDrop={this.props.OnDrop}
                    InputFile={this.props.InputFile ? this.props.InputFile : undefined}
                    AcceptedFiles={this.props.AcceptedFiles} CustomClassName="small"
                    NoFileMessage={Trad.Trad("CaricaDocumento")} />
                <BottoneAPI InviaFile Default Testo={Trad.Trad("Salva")}
                    URL={this.props.SaveURL}
                    Metodo="POST"
                    OnInvio={(s) => this.props.OnSubmitSave()}
                    OnClick={(s, d) => this.props.OnFileSaved(d)}
                    OnErrore={(s, e) => this.props.OnErroreBottoneAPI(s)} />
            </React.Fragment>;
        }

        return <div className="drop-document kt-portlet kt-portlet--height-fluid">
            <div className="kt-portlet__head">
                <DocumentHeader OnDrop={this.props.OnDrop}
                    OnComponentChange={this.props.OnComponentChange}
                    Label={label}
                    AddEnabled={this.props.AddEnabled} />
            </div>
            <div className="kt-portlet__body">
                <div className="kt-widget4">
                    <div className="document-list">
                        <DocumentList OnRemove={this.props.OnRemove} Files={this.props.Files} OnDownloadFile={this.props.OnDownloadFile} AddEnabled={this.props.AddEnabled} />
                    </div>

                    {DropZone}
                </div>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/custom/Document/DocumentBox/DocumentBox.tsx